import { likeDislike } from '@/service/like';
import { useRefreshData } from './useRefreshData';

export const useLikeOrDislike = ({ id }: { id: string }) => {
  const { refreshAudioInList, refreshCatalogOverview } = useRefreshData();

  const likeOrDislike = async () => {
    await likeDislike({ id });
    refreshCatalogOverview();
    // refreshAudioInList({ id });
  };
  return {
    likeOrDislike,
  };
};
